import { useState } from "react";
import { UseLiabilityModalsReturn } from "./types";

export const useLiabilityModals = (): UseLiabilityModalsReturn => {
  const [activateModal, setActivateModal] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [deletePayment, setDeletePayment] = useState({
    id: 0,
    amount: 0,
    isOpen: false,
  });

  return {
    activateModal,
    setActivateModal,
    isDeleteOpen,
    setIsDeleteOpen,
    deletePayment,
    setDeletePayment,
  };
};
